
import {Toast} from 'vant'
import Header from '@/components/header/header.vue'
import { inject, reactive,ref, toRefs, isReactive } from 'vue'
import { useRouter } from 'vue-router'
import listEmpty from '@/components/list_empty.vue';
import { Dialog } from 'vant';
export default { 
  components:{
      [Dialog.Component.name]: Dialog.Component,
    Header,
    listEmpty,
  },
 setup() {
    const $http:any = inject('$http')
      const router = useRouter()
     //删除返回状态
       
      //页面跳转
      const goStore = (goods_id:string):void=>{
          router.push({
              name:'shop',
              params:{
                  id:goods_id
              }
          })
      }
     const product = reactive({
        size:10,
        page:1,
    })
    const finished = ref(false)
    const loading = ref(false)
    const onLoad = async ()=>{   
      get_store_favorite_list()
      }
    let storeListData:any= reactive({
      goods:[]
    })
    const get_store_favorite_list = (async ()=>{       
        const res = await $http.get_store_favorite_list({
               size:product.size,
               page:product.page,
           })
            loading.value = true 
        if(res.code === 200){
          product.page += 1 
             storeListData.goods = storeListData.goods.concat(res.data )
            if(res.data.length < product.size){
                   finished.value = true
             }
            loading.value = false 
        }        
      })
      //添加 删除按钮 
        const deleteClick =  (store_id:any) => {
          Dialog.confirm({
            title: 'Tips?',
            message: 'Are you sure to delete it?',
            confirmButtonText:'Delete',
            cancelButtonText:'Cancel'
            })
            .then(async() => {
                const res = await $http.delete_favorite_goods({
              action: "delete",
              fav_id:store_id,
              fav_type: "store"
            })
            if(res.code == 200) {
                Toast(res.message);
                product.page = 1
                // let arr1:any = []
                storeListData.goods = []
                get_store_favorite_list()
            }              
            })
            .catch(() => {
              //取消
            });
           
        }

      return {
        storeListData,
        loading,
        finished,
        onLoad,
        deleteClick,
        goStore,
      }
 }
} 
